import { makeStyles } from '@material-ui/core';

export default makeStyles(
  () => ({
    container: {
      padding: '40px 60px',
      maxWidth: '440px',
    },
  }),
  { name: 'PassworRecovery' },
);
